var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactCenterInteractionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "interaction",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.473,
    height: 51.473,
    viewBox: "0 0 51.473 51.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3393",
    "data-name": "Path 3393",
    d: "M46.9,0a4.514,4.514,0,0,0-4.48,4.091L32.43,6.563a10.507,10.507,0,0,0-19.151-.726l-4.29-1.4A4.561,4.561,0,1,0,8.022,7.3L12.3,8.69a10.505,10.505,0,0,0-.189,1.866,10.361,10.361,0,0,0,2.132,6.292L9.528,21.565a4.471,4.471,0,0,0-1.938-.453,4.524,4.524,0,1,0,4.524,4.524,4.471,4.471,0,0,0-.453-1.938l4.592-4.827a10.41,10.41,0,0,0,1.14.772V15.927a7.54,7.54,0,1,1,10.556,0v2.678a5.253,5.253,0,0,1,2.058-.487,10.76,10.76,0,0,0,1.317-1.55L36.3,19.056a4.443,4.443,0,0,0-.055.548,4.547,4.547,0,1,0,1.393-3.252l-5-2.5a10.33,10.33,0,0,0,.587-3.3A10.293,10.293,0,0,0,33.119,9.5L43.131,7.02A4.52,4.52,0,0,0,46.9,9.048a4.572,4.572,0,0,0,4.574-4.524A4.572,4.572,0,0,0,46.9,0Z",
    fill: "#7dbaab"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(13.641 9.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    "data-name": "Path 3394",
    d: "M167.337,108.1a2.278,2.278,0,0,0-2.262,2.262v2.262a1.508,1.508,0,1,1-3.016,0v-5.278a2.262,2.262,0,1,0-4.524,0v5.278a1.508,1.508,0,1,1-3.016,0v-8.294a2.262,2.262,0,1,0-4.524,0v8.294a1.508,1.508,0,1,1-3.016,0V92.262a2.262,2.262,0,1,0-4.524,0V108.88l-5.067,4.041a4.6,4.6,0,0,0-1.237,5.58l5.64,11.42a4.489,4.489,0,0,0,4.041,2.5h17.04a4.5,4.5,0,0,0,4.343-3.227A60.135,60.135,0,0,0,169.6,112.62v-2.262A2.278,2.278,0,0,0,167.337,108.1Z",
    transform: "translate(-135.688 -90)",
    fill: "#7dbaab"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCenterInteractionIcon);
export default __webpack_public_path__ + "static/media/contact-center-interaction-icon.658d69ed10eba1fc57221919f4a419c5.svg";
export { ForwardRef as ReactComponent };